import { borderRadius, padding } from '@mui/system';
import React, { useState, useEffect } from 'react';

const VideoThumbnail = ({ snapshots, interval = 1000 }) => {
    // Estado para el índice de la instantánea actual
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        // Si no hay instantáneas, no hagas nada
        if (!snapshots || snapshots.length === 0) {
            console.log("saliendo, no hay datos...")
            return;
        }
        console.log("HAY DATOS...")

        // Configura el intervalo para cambiar la instantánea
        const timer = setInterval(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % snapshots.length);
        }, interval);

        // Función de limpieza para detener el intervalo cuando el componente se desmonte
        return () => clearInterval(timer);
    }, [snapshots, interval]);



    // Si no hay instantáneas, muestra un placeholder
    if (!snapshots || snapshots.length === 0) {
        return (
            <div style={thumbnailPlaceholderStyle}>
                <span>Sin Video</span>
            </div>
        );
    }



    // Estilo para el borde colorido, similar a Instagram Stories
    const borderStyle = {
        // 🟢 Creando un degradado de colores para el borde
        border: '4px solid transparent',
        background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2367, #bc1888) border-box',
        mask: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
        //maskComposite: 'exclude',
        borderRadius: '50%',
        overflow: 'hidden',
    };

    return (
        <div style={borderStyle}>
            <div style={thumbnailContainerStyle}>
                <img
                    src={snapshots[currentIndex]}
                    alt=""
                    style={thumbnailImageStyle}
                />
            </div>
        </div>
    );
};

// Estilos para el componente
const commonStyle = {
    borderRadius: '50%',
    width: '150px',
    height: '150px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '4px solid white'
};

const thumbnailContainerStyle = {
    ...commonStyle,
    margin: '0px', // Espacio para el borde
    
};

const thumbnailImageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
};

const thumbnailPlaceholderStyle = {
    ...commonStyle,
    background: '#eee',
    border: '2px solid #ccc',
    color: '#888',
    textAlign: 'center',
};

export default VideoThumbnail;